import React from 'react';
import NewHeader from '../../components/ServicePage/Header/NewHeader';
import Overview from '../../components/ServicePage/Overview/Overview';
import HexagonalCard from '../../components/WeAreXpressBees/HexagonalCard';
import OurServices from '../../components/ServicePage/OurServices/OurServices';
import HowItWorks from '../../components/ServicePage/HowItWorks/HowItWorks';
import HowWeDrivePerformance from '../../components/ServicePage/HowWeDrivePerformance/HowWeDrivePerformance';
import Industries from '../../components/ServicePage/Industries/Industries';
import WhyChooseUs from '../../components/ServicePage/WhyChooseUs/WhyChooseUs';
import KeyBenefits from '../../components/ServicePage/KeyBenefits/KeyBenefits';
import ClientCarousel from '../../components/ClientCarousel/ClientCarousel';
import FAQ from '../../components/ServicePage/FAQ/FAQ';
import Testimonials from '../../components/Testimonial/Testimonial';

const IndividualServiceSharedLayout = ({ pageData }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '48px',
      }}
    >
      <NewHeader data={pageData.overview} />
      <Overview data={pageData.overview} />
      {/* <HexagonalCard data={pageData?.weAreXpressBeesDetails} /> */}
      <HowWeDrivePerformance data={pageData?.xbFacilityDetails} />
      <HowItWorks data={pageData?.howItWorksConfig} />
      <Industries data={pageData.industriesData} />
      {/* <WhyChooseUs data={pageData?.whyChooseUsDetails} /> */}
      <KeyBenefits data={pageData?.keyBenefitsDetails} />
      <WhyChooseUs data={pageData?.xpressBeesPlatformDetails} />
      <ClientCarousel data={pageData.clientCarousel} />
      <Testimonials />
      <FAQ data={pageData.faqData} />
    </div>
  );
};

export default IndividualServiceSharedLayout;
